import { createSlice } from '@reduxjs/toolkit';

import { COLLECTION_IDS } from '@/constants/collections';
import { DEFAULT_FILTERS_KEYS_MAP } from '@/constants/filters';
import {
  Currency,
  FiltersPosition,
  Language,
  LocationMarker,
  MapsProvider,
  MediaType,
  RouterType,
} from '@/interfaces/settings.interfaces';

import type { ConfigState } from './types';

const initialState: ConfigState = {
  element: '',
  apiRoot: '',
  apiKey: '',
  spaceId: '',
  envId: '',
  navigation: {
    type: RouterType.Hash,
  },
  filters: {
    enable: true,
    position: FiltersPosition.Left,
  },
  models: {
    enable: false,
    filterKey: DEFAULT_FILTERS_KEYS_MAP.MODEL,
    useAggregatePrice: false,
  },
  sort: {
    enable: true,
    initialValues: ['price'],
    items: [
      {
        key: 'price',
        label: 'sort.price',
        icon: 'sort-up',
      },
      {
        key: '-price',
        label: 'sort.price',
        icon: 'sort-down',
      },
    ],
  },
  maps: {
    provider: MapsProvider.Yandex,
    key: '',
  },
  booking: {
    enable: false,
    apiRoot: '',
    collectionId: COLLECTION_IDS.vehiclesBooking,
  },
  locationMarker: LocationMarker.City,
  media: {
    type: MediaType.Images,
    apiRoot: '',
  },
  language: Language.Ru,
  currency: Currency.RUB,
  constructor: {},
};

export const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {},
});

export default configSlice.reducer;
